export const AUTH_TOKEN = 'auth_token'
export const USER_ID = 'userId'

